import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { SYMBOL } from '../../../brands/default/constants';
import { PREFORMATTED_STRING } from '../../../brands/default/content/components/checkout';
import { WOWCHER_ONLY_VIP_REWARDS } from '../../../brands/default/features';
import { LINK_ECOMMERCE_TERMS } from '../../../brands/default/links';
import {
  CROWN_ICON,
  TAG_ICON,
  TROPHY_ICON,
} from '../../../config/constants/images';
import { formatPrice } from '../../../helpers/currency';
import ThemeContext from '../../../providers/ThemeProvider';

const VipPostButtonMessage = ({
  currencySymbol,
  creditAmount,
  discount,
  isBeginOpen = true,
  vipOneYearCost,
}) => {
  const theme = useContext(ThemeContext);
  const displayDiscount = formatPrice(discount, true);
  const isDiscountGreaterVipYearCost = discount > vipOneYearCost;
  const [isOpen, setIsOpen] = useState(isBeginOpen);
  const chevronIcon = isOpen ? faCaretUp : faCaretDown;
  const primaryColorUrlencoded = encodeURIComponent(theme.colors.primary);

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="message-container">
        <div className="message">
          <div className="vip-caret">
            <FontAwesomeIcon
              color={theme.commoncolors.grey}
              icon={chevronIcon}
              onClick={handleButtonClick}
            />
          </div>

          <p className="paragraph-one">
            <b>
              {isDiscountGreaterVipYearCost && (
                <>
                  Join {PREFORMATTED_STRING.brandTerminology.brand} VIP to{' '}
                  <span className="primary">
                    SAVE <br /> an additional {currencySymbol}
                    {displayDiscount} NOW
                  </span>{' '}
                  and get <br />
                  access to the following:
                </>
              )}{' '}
              {!isDiscountGreaterVipYearCost && isBeginOpen && (
                <>
                  Join {PREFORMATTED_STRING.brandTerminology.brand} VIP and get
                  access to the following:
                </>
              )}{' '}
              {!isDiscountGreaterVipYearCost && !isBeginOpen && (
                <>
                  Join {PREFORMATTED_STRING.brandTerminology.brand} VIP to
                  benefit from EXCLUSIVE deals, codes, discount and more!
                </>
              )}{' '}
            </b>
          </p>
          {isOpen && (
            <>
              <ul className="list">
                {creditAmount && (
                  <li className="list-item list-item-moneybag">
                    <span className="primary">
                      GET {SYMBOL}
                      {creditAmount} CREDIT
                    </span>{' '}
                    at every renewal - Don&apos;t miss out!
                  </li>
                )}
                <li className="list-item list-item-crown">
                  <span className="primary">EXTRA DISCOUNT ON</span> eligible
                  deals saving you more! Don&#39;t miss out!
                </li>
                <li className="list-item list-item-tag">
                  Qualify for <span className="primary">COMPLEMENTARY</span> and{' '}
                  <span className="primary">EXCLUSIVE</span> products from our
                  top merchants!
                </li>
                <li className="list-item list-item-trophy">
                  <span className="primary">FREE ENTRY</span> into all of our
                  competitions. You could be in with a chance to{' '}
                  <span className="primary">WIN</span> prizes of up to{' '}
                  <span className="primary">{`${SYMBOL}20,000!`}</span>
                </li>
                <li className="list-item list-item-support">
                  <span className="primary">PRIORITY CUSTOMER SERVICE</span>{' '}
                  guaranteed 24 hour response from our Customer Service Team.
                </li>
                {WOWCHER_ONLY_VIP_REWARDS && (
                  <li className="list-item list-item-present">
                    Unlock <span className="primary">UNIQUE</span> rewards from
                    top brands like Audible, Ancestry, and more!
                  </li>
                )}
              </ul>
              <p style={{ textAlign: 'center' }}>
                View VIP T&Cs{' '}
                <a
                  href={LINK_ECOMMERCE_TERMS.href + '#vip'}
                  rel="noreferrer"
                  target="_blank"
                >
                  here
                </a>
              </p>
            </>
          )}
        </div>
      </div>
      <style jsx>{`
        .message-container {
          margin: 0 -15px -15px -15px;
          padding-top: 15px;
        }
        .message {
          background-color: ${theme.commoncolors.greyx2lighter};
          border-radius: 0 0 7px 7px;
          color: ${theme.commoncolors.black};
          padding: 15px;
        }
        .paragraph-one {
          font-size: 16px;
          margin: ${
            isDiscountGreaterVipYearCost
              ? '0 0 15px 0;'
              : '15px 30px 15px 30px;'
          }
          text-align: center;
        }
        .list {
          margin-left: auto;
          margin-right: auto;
          padding: 0;
          width: 95%;
        }
        .list-item {
          background-position: 0 5px;
          background-repeat: no-repeat;
          background-size: 45px;
          font-size: 14px;
          list-style: none;
          margin-bottom: 10px;
          padding-left: 60px;
        }
        .list-item-crown {
          background-image: url(${CROWN_ICON});
        }
        .list-item-moneybag {
          background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20shape-rendering%3D%22geometricPrecision%22%20text-rendering%3D%22geometricPrecision%22%20image-rendering%3D%22optimizeQuality%22%20fill%3D%22${primaryColorUrlencoded}%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20viewBox%3D%220%200%20394%20511.98%22%3E%3Cpath%20d%3D%22M158.912%2088.115c-7.903-23.315-15.02-46.892-21.026-70.838%2022.398-24.583%20108.964-21.316%20133.86-.384l-23.05%2054.803c12.396-16.286%2016.563-22.97%2023.958-32.043a71.446%2071.446%200%20018.787%206.814c6.557%205.936%2012.412%2012.495%2013.597%2021.638.768%205.929-.927%2011.952-6.203%2018.111l-52.884%2061.595c-6.807-1.116-13.459-2.75-19.914-5.044%202.999-7.058%206.616-14.823%209.615-21.882l-19.253%2020.795c-20.058-4.232-36.188-1.707-51.219%206.242l-53.632-64.366c-3.186-3.839-4.636-7.678-4.624-11.517.051-15.559%2023.218-28.987%2035.396-34.07l26.592%2050.146zm30.877%20243.5h20.122v15.89H192.12c-.227%203.735-.905%207.107-2.06%2010.118-.928%202.286-2.467%204.663-4.64%207.13%202.467-.543%204.595-.815%206.361-.815%202.263%200%205.205.43%208.828%201.29%204.956%201.132%208.918%201.698%2011.883%201.698%202.422%200%204.527-.204%206.315-.611%201.811-.408%204.165-1.268%207.062-2.581l9.032%2019.829c-4.369%202.173-8.217%203.69-11.544%204.527-3.305.838-6.859%201.245-10.661%201.245-4.165%200-8.896-.724-14.261-2.173-7.016-1.924-11.363-3.033-13.06-3.35a31.426%2031.426%200%2000-5.433-.453c-5.704%200-11.997%201.992-18.878%205.976l-8.601-18.878c9.325-6.655%2013.988-13.31%2013.988-19.964%200-.363-.045-1.359-.136-2.988h-13.852v-15.89h9.914c-1.675-5.818-2.648-9.213-2.852-10.141-.272-1.404-.408-3.147-.408-5.229%200-5.523%201.471-10.48%204.414-14.872%202.92-4.391%206.791-7.582%2011.59-9.552%204.798-1.992%2011.249-2.988%2019.376-2.988%207.605%200%2013.626.86%2018.063%202.558%204.436%201.698%208.194%204.528%2011.25%208.466%203.078%203.961%205.183%208.737%206.338%2014.351l-25.398%203.961c-1.267-4.708-2.738-7.832-4.391-9.371-1.652-1.539-3.531-2.309-5.636-2.309-2.558%200-4.618.838-6.202%202.512-1.584%201.676-2.377%204.052-2.377%207.131%200%201.652.158%203.214.475%204.731.295%201.539%201.359%205.115%203.17%2010.752zm37.85-127.206l-10.467-47.871c44.832%208.338%20116.691%2099.534%20139.911%20140.998%2011.852%2021.164%2022.232%2044.48%2030.731%2070.545%2016.931%2063.08.622%20122.093-67.807%20135.838-42.877%208.614-122.838%209.224-167.93%206.891-48.476-2.509-123.494-2.432-143.09-52.204-31.628-80.338%2026.319-176.045%2079.155-234.623%206.952-7.708%2014.141-14.892%2021.579-21.522%2019.219-16.91%2039.943-36.976%2064.682-45.319l-23.895%2044.495%2034.705-46.011h18.288l24.138%2048.783zm-119.957%2088.228c25.48-47.867%2084.932-66.014%20132.799-40.535%2047.867%2025.48%2066.014%2084.932%2040.535%20132.799-25.48%2047.867-84.932%2066.014-132.799%2040.535-47.868-25.48-66.014-84.932-40.535-132.799z%22%2F%3E%3C%2Fsvg%3E");
          background-position: 6px 0;
          background-size: 35px;
        }
        .list-item-tag {
          background-image: url(${TAG_ICON});
          background-size: 40px;
        }
        .list-item-trophy {
          background-image: url(${TROPHY_ICON});
        }
        .list-item-support {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960'%3E%3Cpath fill='${primaryColorUrlencoded}' d='M440-120v-80h320v-284q0-117-81.5-198.5T480-764q-117 0-198.5 81.5T200-484v244h-40q-33 0-56.5-23.5T80-320v-80q0-21 10.5-39.5T120-469l3-53q8-68 39.5-126t79-101q47.5-43 109-67T480-840q68 0 129 24t109 66.5Q766-707 797-649t40 126l3 52q19 9 29.5 27t10.5 38v92q0 20-10.5 38T840-249v49q0 33-23.5 56.5T760-120H440Zm-80-280q-17 0-28.5-11.5T320-440q0-17 11.5-28.5T360-480q17 0 28.5 11.5T400-440q0 17-11.5 28.5T360-400Zm240 0q-17 0-28.5-11.5T560-440q0-17 11.5-28.5T600-480q17 0 28.5 11.5T640-440q0 17-11.5 28.5T600-400Zm-359-62q-7-106 64-182t177-76q89 0 156.5 56.5T720-519q-91-1-167.5-49T435-698q-16 80-67.5 142.5T241-462Z'/%3E%3C/svg%3E");
          background-position: 0 -2px;
          background-size: 50px;
        }
                .list-item-present {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960'%3E%3Cpath fill='${primaryColorUrlencoded}' d='M160-80v-440H80v-240h208q-5-9-6.5-19t-1.5-21q0-50 35-85t85-35q23 0 43 8.5t37 23.5q17-16 37-24t43-8q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h208v240h-80v440H160Zm400-760q-17 0-28.5 11.5T520-800q0 17 11.5 28.5T560-760q17 0 28.5-11.5T600-800q0-17-11.5-28.5T560-840Zm-200 40q0 17 11.5 28.5T400-760q17 0 28.5-11.5T440-800q0-17-11.5-28.5T400-840q-17 0-28.5 11.5T360-800ZM160-680v80h280v-80H160Zm280 520v-360H240v360h200Zm80 0h200v-360H520v360Zm280-440v-80H520v80h280Z'/%3E%3C/svg%3E");
          background-position: 0 -2px;
          background-size: 50px;
        }
        .primary {
          color: ${theme.colors.primary};
          font-weight: bold;
        }
        .vip-caret {
          color: ${theme.colors.primary};
          cursor: pointer;
          font-size: 3rem;
          padding-right: 25px;
          position: absolute;
          right: 0;
        }
        @media (min-width: ${theme.breakpoints.xxs}) {
          .paragraph-one {
            font-size: 18px;
          }
          .list-item {
            font-size: 16px;
          }
        }
        @media (min-width: ${theme.breakpoints.xs}) {
          .list {
            width: 60%;
          }
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .list {
            width: 50%;
          }
          .list-item {
            font-size: 16px;
          }
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .list {
            width: 50%;
          }
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          .list {
            width: 70%;
          }
        }
      `}</style>
    </>
  );
};

VipPostButtonMessage.propTypes = {
  currencySymbol: PropTypes.string,
  discount: PropTypes.number,
  isBeginOpen: PropTypes.bool,
  vipOneYearCost: PropTypes.number,
};

export default VipPostButtonMessage;
